/** Session flag: show portal boot overlay once after `login()` until cleared when animation finishes or user logs out. */
export const PORTAL_BOOT_PENDING_KEY = "taistu_portal_boot_pending";
